// import router from "../router"
// import * as homeApi from '../api/index'
// import * as homeApi from '../api/index';
// import service from './service'
// 打开客服
function checkServier(){
	let userId = JSON.parse(localStorage.getItem('userInfo'))?JSON.parse(localStorage.getItem('userInfo')).user_id:""
	let id = userId?"ID："+userId:"未登录"
  let contactUs = JSON.parse(localStorage.getItem('datum'))
  location.href = contactUs ?contactUs.linkPc?contactUs.linkPc:contactUs.link:'/'
	// var api = $53.createApi();
	// api.push('cmd','member');
	// api.push('name',id);
	// api.query();
	// api.push('cmd', 'kfclient');
	// api.push('type', 'popup');
	// api.query()

}
function checkPhone(mobile){
	return !mobile.match(/^1[3|4|5|6|7|8|9][0-9]{9}$/);
}
function checkWxLogin(){
	api.getWithdrawAppIdForKf({

	}).then(res => {
    console.log(res)
    return
		let url = encodeURIComponent('https://www.tuantuanshou.com')
		let appid = 'wxb4b6351be89f4301'
		let wxurl = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&redirect_uri='+url+'&response_type=code&scope=snsapi_login&state=#wechat_redirect'
		window.open(wxurl, "TencentLogin", "width=500,height=400,menubar=0,scrollbars=1, resizable=1,status=1,titlebar=0,toolbar=0,location=1")
	})
}
function checkHide(mobile){
	if(mobile){
		return mobile.substr(0,3) + "****" + mobile.substr(7);
	}
		return
}

function checkGoOut(){
	route.replace({ path: "/login" });

}
module.exports = {
	checkServier:checkServier,
	checkPhone:checkPhone,
	checkWxLogin:checkWxLogin,
	checkGoOut:checkGoOut,
	checkHide:checkHide
}



// WEBPACK FOOTER //
// ./src/common/common.js